<template>
  <v-app>
    <div class="flex justify-center">
      <div class="relative w-full">
        <Navbar
          class="text-white"
          v-if="
            (!$route.path.includes('/login') && $route.path.name == 'Login') ||
              $route.path.includes('property_selection') ||
              $route.path.includes('home') ||
              $route.path.includes('customer-dashboard') ||
              $route.path.includes('admin-dashboard-screen') ||
              $route.path.includes('my-documents') ||
              $route.path.includes('submit-documents') ||
              $route.path.includes('book_appointment') ||
              $route.path.includes('request-documents')
          "
        ></Navbar>
        <NavbarSignup
          v-if="$route.path.includes('/login/signup/bis')"
        ></NavbarSignup>
        <div class="md:flex">
          <div
            class="md:w-1/4 ml-2"
            v-if="
              $route.name == 'Moldex Buyers Guide' ||
                $route.name == 'buyers_guide_content' ||
                $route.name == 'FAQ' ||
                $route.path == '/home/my-documents' ||
                $route.path == '/home/request-documents' ||
                $route.path == '/home/book_appointment' ||
                $route.path == '/home/book_appointment/calendar' ||
                $route.path == '/home/book_appointment/time_table' ||
                $route.path == '/home/book_appointment/summary' ||
                $route.path == '/home/book_appointment/note' ||
                $route.path == '/home/submit-request' ||
                $route.path == '/home/issuance' ||
                $route.path == '/home/my-account' ||
                $route.path == '/home/dashboard' ||
                $route.path.includes('admin/admin-dashboard-screen') ||
                $route.path.includes('statement-of-account') ||
                $route.path.includes('inquiry') ||
                $route.path.includes('customer-dashboard')
            "
          >
            <AdminSidebar v-if="role == 'admin'" />
            <Sidebar v-else />
          </div>
          <div class="w-full">
            <router-view />
          </div>
        </div>
      </div>
    </div>
  </v-app>
</template>

<script>
import Navbar from "./common/Navbar.vue";
import NavbarSignup from "./common/NavbarSignup";
import Sidebar from "./common/Sidebar.vue";
import AdminSidebar from "./screens/adminScreen/components/AdminSidebar.vue";
// import Topbar from "./components/Topbar";
import logout from "./utils/logout";
import SecureStorage from "./utils/secureStorage";

export default {
  data() {
    return {
      idleTime: null,
      idleLimit: 15 * 60 * 1000, // 10 minutes in milliseconds IDLE time
      role: "",
      authorized: "",
    };
  },
  methods: {
    startIdleTimer() {
      this.idleTime = setTimeout(() => {
        this.logoutUser();
      }, this.idleLimit);
    },
    resetIdleTimer() {
      clearTimeout(this.idleTime);
      this.startIdleTimer();
    },
    async logoutUser() {
      try {
        logout();
      } catch (error) {
        console.log(error);
      }
    },
  },
  watch: {
    "$route.name": {
      handler() {
        const auth = SecureStorage.getItem("auth");
        this.authorized = auth ? auth.authorized : false;
        this.role = auth ? auth.role : "";
      },
      immediate: true,
    },
  },
  components: {
    Navbar,
    NavbarSignup,
    Sidebar,
    AdminSidebar,
    // Topbar,
  },
  mounted() {
    // this.startIdleTimer();
    // window.addEventListener("mousemove", this.resetIdleTimer);
    // window.addEventListener("keydown", this.resetIdleTimer);
    // window.addEventListener("click", this.resetIdleTimer);
    // window.addEventListener("scroll", this.resetIdleTimer);
  },
  beforeDestroy() {
    window.removeEventListener("mousemove", this.resetIdleTimer);
    window.removeEventListener("keydown", this.resetIdleTimer);
    window.removeEventListener("click", this.resetIdleTimer);
    window.removeEventListener("scroll", this.resetIdleTimer);
    clearTimeout(this.idleTime);
  },
};
</script>
